var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAniaLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddeaf4;}.cls-2{fill:#007cba;}.cls-3{fill:#231f20;}.cls-4{fill:#636466;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANIA-185-Broadway-LP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M49,32.91,26,10V50a23.67,23.67,0,0,0,15.62-5.77A26.56,26.56,0,0,0,49,32.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M26,52a26,26,0,1,1,18.38-7.62A26,26,0,0,1,26,52Zm-3.25-4a22.83,22.83,0,0,0,6.5,0L26,44.76ZM26,39.45,33.5,47a22.07,22.07,0,0,0,6.84-4L26,28.66,11.66,43a22.3,22.3,0,0,0,6.84,4Zm0-16.1,17,17a22.05,22.05,0,0,0,4-7l-21-21-21,21a22.36,22.36,0,0,0,4,7Zm0-19.6A22.29,22.29,0,0,0,4,29.11l22-22,22,22A22.29,22.29,0,0,0,26,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-3",
    d: "M77.72,30.8h6.45L80.9,23.57ZM87.87,39l-1.48-3.33H75.6L74.13,39H68L80.2,12h1.36L94,39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    "data-name": "Path",
    className: "cls-3",
    points: "114.75 12 121 12 121 39 118.36 39 103.33 24.31 103.33 39 97 39 97 12 99.68 12 114.75 26.77 114.75 12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "cls-3",
    x: 126,
    y: 12,
    width: 7,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-3",
    d: "M144.76,30.79h6.47L148,23.56ZM154.87,39l-1.47-3.31H142.64L141.16,39H135l12.2-27h1.36L161,39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    "data-name": "Path",
    className: "cls-4",
    points: "173 19 175.27 19 182.5 29.91 189.73 19 192 19 192 39 189.76 39 189.76 22.8 182.53 33.51 182.41 33.51 175.18 22.83 175.18 39 173 39 173 19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-4",
    d: "M210.44,31.73,206,21.6l-4.52,10.13ZM205,19H207l9,20h-2.39l-2.31-5.24H200.61L198.28,39H196Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    "data-name": "Path",
    className: "cls-4",
    points: "220 19 222.13 19 234.79 35.03 234.79 19 237 19 237 39 235.19 39 222.21 22.59 222.21 39 220 39 220 19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-4",
    d: "M255.44,31.72,251,21.6l-4.52,10.12ZM250,19H252l9,20h-2.39l-2.31-5.24H245.6L243.27,39H241Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    className: "cls-4",
    d: "M262,29.06V29a9.79,9.79,0,0,1,9.9-10,10.55,10.55,0,0,1,7.36,2.57l-1.44,1.65a8.5,8.5,0,0,0-6-2.18A7.63,7.63,0,0,0,264.31,29V29c0,4.6,3,8,7.81,8a9.41,9.41,0,0,0,5.7-1.92V30.3h-6v-2H280V36a12.17,12.17,0,0,1-7.93,3,9.58,9.58,0,0,1-10-9.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    "data-name": "Path",
    className: "cls-4",
    points: "286 19 299.87 19 299.87 21.06 288.16 21.06 288.16 27.89 298.63 27.89 298.63 29.94 288.16 29.94 288.16 36.94 300 36.94 300 39 286 39 286 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    "data-name": "Path",
    className: "cls-4",
    points: "304 19 306.27 19 313.5 29.91 320.73 19 323 19 323 39 320.76 39 320.76 22.8 313.53 33.51 313.41 33.51 306.18 22.83 306.18 39 304 39 304 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    "data-name": "Path",
    className: "cls-4",
    points: "329 19 342.86 19 342.86 21.06 331.17 21.06 331.17 27.89 341.63 27.89 341.63 29.94 331.17 29.94 331.17 36.94 343 36.94 343 39 329 39 329 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    "data-name": "Path",
    className: "cls-4",
    points: "347 19 349.13 19 361.79 35.03 361.79 19 364 19 364 39 362.19 39 349.21 22.59 349.21 39 347 39 347 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    "data-name": "Path",
    className: "cls-4",
    points: "369 19 369 21.08 375.41 21.08 375.41 39 377.59 39 377.59 21.08 384 21.08 384 19 369 19"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAniaLogoFull);
export default __webpack_public_path__ + "static/media/AniaLogo-full.5c4848790498c4507f528b5b1a8c9628.svg";
export { ForwardRef as ReactComponent };